<template>
  <div class="detail-page">
    <Loading v-if="loading"></Loading>
    <template v-else-if="detail.orderId">
      <!-- 订单信息 -->
      <div class="section">
        <div class="section-title">订单信息</div>
        <div class="info-row">
          <span class="label">订单编号</span>
          <span class="value">{{ detail.orderNo || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">订单状态</span>
          <span class="value">
            <van-tag :type="getStatusType(detail.lifecycleStatus)">{{
              getStatusText(detail)
            }}</van-tag>
          </span>
        </div>
        <div class="info-row">
          <span class="label">创建时间</span>
          <span class="value">{{ detail.createTime || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">订单渠道</span>
          <span class="value">{{ getChannelText(detail) }}</span>
        </div>
        <div class="info-row">
          <span class="label">总金额</span>
          <span class="value">{{ detail.totalAmount ?? "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">折扣金额</span>
          <span class="value">{{ formatAmount(detail.discountAmount) }}</span>
        </div>
        <div class="info-row">
          <span class="label">实收金额</span>
          <span class="value">{{
            detail.receivedAmount ?? detail.payAmount ?? "-"
          }}</span>
        </div>
      </div>

      <!-- 支付信息 -->
      <div class="section">
        <div class="section-title">支付信息</div>
        <div class="info-row">
          <span class="label">支付时间</span>
          <span class="value">{{ detail.payTime || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">购买方创客id</span>
          <span class="value">{{ detail.merchId || detail.userId || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">购买方创客手机号</span>
          <span class="value">{{ detail.phone || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">支付方式/金额</span>
          <span class="value">{{ getPayTypeText(detail) }}</span>
        </div>
      </div>

      <!-- 商品信息 -->
      <div class="section">
        <div class="section-title">商品信息</div>
        <div
          class="product-item"
          v-for="(product, index) in detail.products"
          :key="product.productId || index"
        >
          <div class="product-top">
            <span class="product-name">{{ product.productName || "-" }}</span>
            <span class="product-num">×{{ product.orderNum ?? 1 }}</span>
          </div>
          <div class="product-bottom">
            <span class="product-spec">{{ product.skuSpec || "规格" }}</span>
            <span class="product-price">￥{{ product.taxPrice ?? "0.00" }}</span>
          </div>
        </div>
        <div v-if="!detail.products || !detail.products.length" class="empty">
          暂无商品信息
        </div>
      </div>

      <!-- 售后记录（afterSaleRecords 长度大于1时展示） -->
      <div class="section" v-if="afterSaleList.length >= 1">
        <div class="section-title">售后记录</div>
        <div
          class="after-sale-item"
          v-for="(record, index) in afterSaleList"
          :key="record.afterSaleId || index"
          @click="goAfterSale(record)"
        >
          <!-- 第一行：售后订单号、服务类型、状态 -->
          <div class="as-row top">
            <span class="as-no">{{ record.afterSaleNo || "-" }}</span>
            <span class="as-type">{{ record.serviceType || "-" }}</span>
            <span class="as-status">{{ record.statusDesc || "-" }}</span>
          </div>
          <div class="as-row">
            <span class="label">申请时间</span>
            <span class="value">{{ record.applyTime || "-" }}</span>
          </div>
          <div class="as-row">
            <span class="label">审核时间</span>
            <span class="value">{{ record.auditTime || "-" }}</span>
          </div>
          <div class="as-row">
            <span class="label">退款金额</span>
            <span class="value">{{
              record.refundAmount != null ? "￥" + record.refundAmount : "-"
            }}</span>
          </div>
          <div class="as-row">
            <span class="label">申请原因</span>
            <span class="value">{{ record.applyReason || "-" }}</span>
          </div>
          <div class="as-row">
            <span class="label">用户备注</span>
            <span class="value">{{ record.userRemark || "-" }}</span>
          </div>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
    </template>
    <div v-else class="empty">暂无订单信息</div>
  </div>
</template>
<script>
import { queryDetail } from "@/service/api/retail/order";
import Loading from "../../../components/loading.vue";

export default {
  name: "RetailOrderDetail",
  components: { Loading },
  data() {
    return {
      orderId: this.$route.params.id || "",
      loading: true,
      detail: {},
      // 订单渠道：3-静态码 4-收银台 5-自助机
      channelOptions: [
        { label: "静态码", value: 3 },
        { label: "收银台", value: 4 },
        { label: "自助机", value: 5 },
      ],
      // 订单状态
      statusOptions: [
        { label: "待支付", value: 100 },
        { label: "已完成", value: 500 },
        { label: "已取消", value: 600 },
      ],
    };
  },
  mounted() {
    this.getDetail();
  },
  computed: {
    afterSaleList() {
      return this.detail.afterSaleRecords || [];
    },
  },
  methods: {
    getDetail() {
      this.loading = true;
      queryDetail(this.orderId)
        .then((res) => {
          this.detail = res.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 跳转售后订单详情页
    goAfterSale(record) {
      this.$router.push(`/retail/afterSaleDetail/${record.afterSaleId}`);
    },
    // 金额为空或0时展示 --
    formatAmount(val) {
      if (val === null || val === undefined || val === 0) return "--";
      return val;
    },
    getChannelText(item) {
      if (item.retailTypeDesc) return item.retailTypeDesc;
      const opt = this.channelOptions.find(
        (c) => c.value === item.retailType
      );
      return opt ? opt.label : "-";
    },
    getStatusText(item) {
      if (item.lifecycleStatusDesc) return item.lifecycleStatusDesc;
      const opt = this.statusOptions.find(
        (s) => s.value === item.lifecycleStatus
      );
      return opt ? opt.label : "-";
    },
    getStatusType(status) {
      if (status === 500) return "success";
      if (status === 600) return "danger";
      return "warning";
    },
    // 支付方式/金额：微信 ¥3.5（多笔支付用顿号拼接）
    getPayTypeText(item) {
      if (item.payTypeInfos && item.payTypeInfos.length) {
        const text = item.payTypeInfos
          .map((p) => `${p.payChannelDesc || "-"} ￥${p.payAmount ?? "0"}`)
          .join("、");
        return text || "-";
      }
      return "-";
    },
  },
};
</script>
<style lang="less" scoped>
.detail-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding: 10px 0;
}

.section {
  background: #fff;
  margin: 0 0 10px;
  padding: 15px 16px;

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 2.2;

    .label {
      color: #666;
    }

    .value {
      color: #333;
      text-align: right;
    }
  }
}

.product-item {
  padding: 12px 4px;
  border-top: 1px solid #f4f4f4;

  &:first-of-type {
    border-top: none;
  }

  .product-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .product-name {
      font-size: 15px;
      color: #333;
    }

    .product-num {
      font-size: 14px;
      color: #999;
    }
  }

  .product-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;

    .product-spec {
      font-size: 13px;
      color: #c8c9cc;
    }

    .product-price {
      font-size: 15px;
      font-weight: 600;
      color: #333;
    }
  }
}

.after-sale-item {
  position: relative;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px 32px 12px 12px;
  margin-top: 10px;

  &:first-of-type {
    margin-top: 0;
  }

  .as-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    line-height: 2;
    color: #666;

    .label {
      color: #999;
    }

    .value {
      color: #333;
      text-align: right;
      word-break: break-all;
    }

    &.top {
      .as-no {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .as-type {
        margin: 0 8px;
        font-size: 12px;
        color: #1989fa;
      }

      .as-status {
        font-size: 12px;
        color: #ee0a24;
      }
    }
  }

  .arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #c8c9cc;
    font-size: 16px;
  }
}

.empty {
  text-align: center;
  color: #c8c9cc;
  font-size: 13px;
  padding: 30px 0;
}
</style>
